'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentZippayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M29.8757 23.2644L32.2202 41.999H55.1576L52.8132 23.2644H29.8757Z",
          fill: "#AA8FFF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.6888 36.7637L7.34349 41.999H30.2642L29.5142 36.0034H18.827L18.7336 35.2605L28.5764 28.5094L27.9188 23.2644H5L5.75003 29.2591H16.455L16.5483 30.0088L6.6888 36.7637Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M79.9168 30.0088C79.3879 25.7981 76.0182 23.2461 71.4374 23.2644H56.1802L58.5237 42H65.388L64.9181 38.2525H72.1815C77.8977 38.2515 80.5135 34.7559 79.9168 30.0088ZM71.4394 32.9998L64.2634 33.0075L63.7011 28.5113L70.9174 28.5171C72.6141 28.5373 73.482 29.4752 73.6226 30.7584C73.7091 31.5844 73.3238 32.9988 71.4394 32.9988V32.9998Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M37.4346 20.7751C38.6418 19.503 38.4313 17.3847 36.9646 16.0436C35.4978 14.7025 33.3301 14.6465 32.123 15.9186C30.9158 17.1906 31.1262 19.3089 32.593 20.65C34.0597 21.9911 36.2274 22.0471 37.4346 20.7751Z",
          fill: "black"
        }
      )
    ]
  }
);
const VpPaymentZippayAsset = forwardRef(PaymentZippayAsset);

export { VpPaymentZippayAsset as default };
